function initTOC() {
  const article =
    document.querySelector(".article-template .article-template__content-center") ||
    document.querySelector(".article-template__content-center");

  const tocList = document.querySelector("#toc ul");
  const tableShow = document.querySelector(".article--table-show");

  if (!article || !tocList) return;

  const headers = article.querySelectorAll("h2, h3");
  let currentH2Li = null;

  const setActiveLink = (anchor) => {
    document
      .querySelectorAll(".article--table-content a.active")
      .forEach((el) => el.classList.remove("active"));

    const activeLink = document.querySelector(
      `.article--table-content a[href="#${anchor}"]`
    );

    if (activeLink) activeLink.classList.add("active");
  };

  const observer = new IntersectionObserver(
    () => {
      let activeHeader = null;
      const offsetTop = 100;

      headers.forEach((header) => {
        const rect = header.getBoundingClientRect();

        if (rect.top <= offsetTop) {
          activeHeader = header;
        }
      });

      if (!activeHeader) {
        activeHeader = headers[0];
      }

      const anchor = activeHeader?.dataset.anchor;

      if (anchor && anchor !== currentActiveAnchor) {
        setActiveLink(anchor);
      }
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -80% 0px",
    }
  );

  headers.forEach((header, index) => {
    const anchorId = `header-${index}`;

    header.id = anchorId;
    header.dataset.anchor = anchorId;

    const link = document.createElement("a");
    link.textContent = header.textContent.trim();
    link.href = `#${anchorId}`;
    link.style.cursor = "pointer";

    if (index === 0) link.classList.add("active");

    const li = document.createElement("li");
    li.style.listStyle = "none";

    if (header.tagName === "H2") {
      link.classList.add("table-h2");
      li.appendChild(link);
      tocList.appendChild(li);
      currentH2Li = li;
    }

    if (header.tagName === "H3") {
      link.classList.add("table-h3");

      if (currentH2Li) {
        let subList = currentH2Li.querySelector("ul");

        if (!subList) {
          subList = document.createElement("ul");
          currentH2Li.appendChild(subList);
        }

        li.appendChild(link);
        subList.appendChild(li);
      } else {
        li.appendChild(link);
        tocList.appendChild(li);
      }
    }

    link.addEventListener("click", (e) => {
      e.preventDefault();

      setActiveLink(anchorId);

      const rect = header.getBoundingClientRect();
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--max-height-header').trim()) * 10;

      window.scrollTo({
        top: window.scrollY + rect.top - headerHeight,
        behavior: "smooth",
      });
    });

    observer.observe(header);
  });

  if (tableShow) {
    tableShow.addEventListener("click", () => {
      tocList.classList.toggle("active");
      tableShow.classList.toggle("active");
    });
  }
}

let tocInitTimer = null;

function scheduleInitArticleTOC() {
  clearTimeout(tocInitTimer);
  tocInitTimer = setTimeout(initTOC, 50);
}

if (!window.articleTOCBound) {
  window.articleTOCBound = true;

  document.addEventListener("DOMContentLoaded", scheduleInitArticleTOC);
  document.addEventListener("shopify:section:load", scheduleInitArticleTOC);
}